import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  highlightText: {
    color: theme.palette.info.main,
  },
}));

const ReviewedTarget = ({ reviewedTarget }: { reviewedTarget?: boolean }) => {
  const { classes, cx } = useStyles();

  if (reviewedTarget === undefined) {
    return <></>;
  }

  const reviewedValue = reviewedTarget ? 'Reviewed' : 'Not Reviewed';
  return (
    <>
      <Box sx={{ alignItems: 'center' }} className={classes.row}>
        <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
          Mark as
        </Typography>
        <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
          {reviewedValue}
        </Typography>
        {reviewedTarget && <CheckCircleIcon sx={{ height: 18, width: 18 }} color='success'></CheckCircleIcon>}
      </Box>
    </>
  );
};

export default ReviewedTarget;
